import React, { useState } from 'react'

import Modal from 'components/common/Modal'
import Input from 'components/common/Input'
import Button from 'components_new/atoms/Button'

import { DESCRIPTOR } from 'helpers/Constants'

const CreateDataProduct = ({
  visible,
  onClose,
  tryCreateDataproduct,
  type
}) => {
  const [name, setName] = useState(undefined)

  const descriptor = DESCRIPTOR[type]

  return (
    <Modal
      visible={visible}
      onClose={() => {
        onClose()
        setName(undefined)
      }}
      header={`Skapa ${descriptor}`}
      actions={
        <>
          <Button
            onClick={() => {
              onClose()
              setName(undefined)
            }}
            variant="text"
          >
            Avbryt
          </Button>
          <Button
            onClick={() => {
              const data = {
                attributes: {
                  name: name,
                  type
                }
              }

              tryCreateDataproduct({ data })

              setName(undefined)
              onClose()
            }}
          >
            Skapa
          </Button>
        </>
      }
    >
      <Input
        size="large"
        label={`Namnge ${descriptor}`}
        value={name}
        onChange={(e) => setName(e)}
      />
    </Modal>
  )
}

export default CreateDataProduct
